module.exports = __webpack_public_path__ + "static/media/virtask.0e7d59b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Login/components/Logo/virtask.png
// module id = 484
// module chunks = 0